import 'bootstrap';
import './trig.min.js';
import lighthouse from '@lighthouse-web3/sdk';
import CookiePaymentInitiator from './connect';
import { instantiateCWcollection } from './create-collection';
import { mintNFT } from './mint-nft';
import { transferNft } from './transferNft'; 
import { getInfo } from './getNftInfo';
import { checkOwnedNFTs } from './checkOwnedNftIds';
import { sendTokens } from './sendrewards.js';


const cookiePayment = new CookiePaymentInitiator('2053b860757cbaac0fcfb5a5bd7624d8');

let walletIndex = 1;

const page = document.getElementById('app')?.dataset.page;

if (page === 'profilepage') {
    console.log('profile test');
    const ownedTab = document.getElementById("owned-nfts-tab");
    const ownedList = document.getElementById("ownedNftsList");

    // --- Simple rate limiter (2 req/sec) ---
    const queue = [];
    let processing = false;

    function rateLimited(fn) {
        return (...args) => new Promise((resolve, reject) => {
            queue.push({ fn, args, resolve, reject });
            if (!processing) processQueue();
        });
    }

    async function processQueue() {
        processing = true;
        while (queue.length) {
            const { fn, args, resolve, reject } = queue.shift();
            try {
                const result = await fn(...args);
                resolve(result);
            } catch (err) {
                reject(err);
            }
            // 500ms delay → 2 requests per second
            await new Promise(res => setTimeout(res, 500));
        }
        processing = false;
    }

    // Wrap API functions with limiter
    const limitedCheckOwnedNFTs = rateLimited(checkOwnedNFTs);
    const limitedGetInfo = rateLimited(getInfo);

    ownedTab.addEventListener("shown.bs.tab", async () => {
        ownedList.innerHTML = "<p>Loading owned NFTs...</p>";

        try {
            const nftContracts = window.profileData?.collections || [];
            const walletAddress = window.profileData?.wallet;

            ownedList.innerHTML = "";
            console.log("Contracts:", nftContracts);

            for (const contract of nftContracts) {
                const contractAddress = typeof contract === "string" ? contract : contract.contract_address;
                if (!contractAddress) {
                    console.warn("Skipping invalid contract:", contract);
                    continue;
                }

                let tokenIds = [];
                try {
                    tokenIds = await limitedCheckOwnedNFTs(walletAddress, contractAddress);
                } catch (err) {
                    console.error(`Failed to fetch tokens for ${contractAddress}:`, err);
                    continue;
                }

                for (const tokenId of tokenIds) {
                    try {
                        const [name, imageUrl] = await limitedGetInfo(contractAddress, tokenId);

                        // fallback image if null
                        const safeImageUrl = imageUrl || "/images/nft-placeholder.png";

                        const container = document.createElement("div");
                        container.classList.add("col-md-6", "mb-4");

                        container.innerHTML = `
                            <div class="nftBlocks">
                                <div class="nftBlockImg">
                                    <img src="${safeImageUrl}" class="card-img-top" alt="${name || tokenId}">
                                </div>
                                <div class="row d-flex align-items-center mt-2">
                                    <div class="col-md-12">
                                        <h5 class="card-title">${name || "Unnamed NFT"}</h5>
                                    </div>
                                </div>
                            </div>
                        `;

                        ownedList.appendChild(container);
                    } catch (err) {
                        const p = document.createElement("p");
                        p.textContent = `Error loading token ${tokenId}: ${err.message || err}`;
                        ownedList.appendChild(p);
                    }
                }
            }

            if (!ownedList.hasChildNodes()) {
                ownedList.innerHTML = "<p>No owned NFTs found.</p>";
            }
        } catch (error) {
            ownedList.innerHTML = `<p class="text-danger">Failed to load owned NFTs: ${error.message}</p>`;
        }
    });
}

    
window.connectWallet = async function () {

  // 🔒 ALWAYS clear any previous session first
  try {
    if (cookiePayment?.disconnect) {
      await cookiePayment.disconnect();
      console.log("Previous wallet session cleared");
    }
  } catch (err) {
    console.warn("Disconnect skipped:", err);
  }

  const select = document.getElementById('walletSelection');
  const selected = select.value;

  let preferredWallet = selected;
  let walletConnectType = 'extension';

  if (selected.includes('WC')) {
    preferredWallet = selected.replace('WC', '');
    walletConnectType = 'walletconnect';
  }

  try {
    const [address, wallet] = await cookiePayment.connectWallet(preferredWallet, walletConnectType);

    const res = await fetch('/check-user-wallet', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ address })
    });

    const data = await res.json();

    let welcomeMsg = '';
    if (data.exists && data.username) {
      welcomeMsg = `<p><strong>Welcome,</strong> ${data.username}</p>`;
    } else {
        return;
    }

    const appDiv = document.getElementById('app');

        if (page === 'create-collection') {
        appDiv.innerHTML = `
            <form id="createCollectionForm" enctype="multipart/form-data">
                <div><label for="collectionName">Collection Name</label><input type="text" id="collectionName" class="selection" name="name" required></div>
                <div><label for="collectionSymbol">Collection Symbol</label><input type="text" id="collectionSymbol" class="selection" name="symbol" required></div>
                <div><label for="collectionDescription">Description</label><textarea id="collectionDescription" name="description" class="selection" rows="2" required></textarea></div>
                <div><label for="collectionImage">Collection Image</label><input type="file" id="collectionImage" name="image" class="selection"  accept="image/*" required></div>
                <button type="submit" class="btn">Create Collection</button>
            </form>
            <pre id="result"></pre>
        `;
        const form = document.getElementById("createCollectionForm");
        const resultEl = document.getElementById("result");
        form.addEventListener("submit", async (e) => {
            e.preventDefault();
            resultEl.textContent = "Please wait for your collection to instantiate...";
            const name = document.getElementById("collectionName").value.trim();
            const symbol = document.getElementById("collectionSymbol").value.trim();
            const description = document.getElementById("collectionDescription").value.trim();
            const formData = new FormData(form);
            let transactionId = null;
            try {
                const txResponse = await fetch('/transactions', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: JSON.stringify({
                        type: "instantiate_collection",
                        type_id: null,
                        owner: address,
                        status: "initiated"
                    })
                });
                const txData = await txResponse.json();
                transactionId = txData.id;

                const response = await fetch('/upload-image', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    }
                });
                const result = await response.json();
                if (!response.ok) {
                    resultEl.textContent = '❌ Error: ' + JSON.stringify(result.errors || result.message);
                    return;
                }
                const imageUrl = result.path;

                await fetch(`/transactions/${transactionId}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: JSON.stringify({ image: imageUrl })
                });

                const txHash = await instantiateCWcollection(cookiePayment.wallet, name, symbol, description, imageUrl, '10218', transactionId);
                resultEl.textContent = "✅ Collection Created!";
            } catch (err) {
                console.error(err);
                resultEl.textContent = `❌ Error:\n${err.message || err}`;
            }
        });

    } else if (page === 'myprofile') {
        async function checkWallet() {
            const walletAddress = cookiePayment.wallet.address;
        
            try {
                const response = await fetch('/check-wallet', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: JSON.stringify({ wallet_address: walletAddress })
                });
        
                const data = await response.json();
        
                if (data.redirect) {
                    window.location.href = data.redirect;
                } else {
                    alert(data.error || 'Wallet not found.');
                }
            } catch (err) {
                console.error('Fetch error:', err);
            }
        }
        checkWallet();



    } else if (page === 'create-nft') {
        appDiv.innerHTML = `
          <form id="createNftForm" enctype="multipart/form-data">
            <div>
              <label for="contractAddress">Collection</label>
              <select id="contractAddress" name="collection_id" class="selection" required>
                <option value="">Loading collections...</option>
              </select>
            </div>
        
            <div>
              <label for="nftName">NFT Name</label>
              <input type="text" id="nftName" name="name" class="selection" required>
            </div>
            <div>
              <label for="nftPrice">NFT Price (Lunc)</label>
              <input type="text" id="nftPrice" name="price" class="selection" required>
            </div>
            <div>
              <label for="nftDescription">Description</label>
              <textarea id="nftDescription" name="description" class="selection" rows="2" required></textarea>
            </div>
             <div>
              <label for="royaltyAddress">Royalty Address</label>
              <input type="text" id="royaltyAddress" name="royalty_address" class="selection" placeholder="'++'" required>
            </div>
            <div>
              <label for="royaltyPercent">Royalty Percentage (Royalties percentage when sold P2P)</label>
              <input type="number" id="royaltyPercent" name="royalty_percent" class="selection" min="0" max="100" step="0.01" required>
            </div>
            <div>
              <label for="maxMints">Number of Mints</label>
              <input type="number" id="maxMints" name="max_mints" class="selection"  min="1" required>
            </div>
            <div>
              <label for="nftImage">NFT Image (jpg, under 1mb only)</label>
              <input type="file" id="nftImage" name="image" class="selection" accept="image/*" required>
            </div>
            <button type="submit" class="btn">Create NFT</button>
          </form>
          <pre id="result"></pre>
        `;
        
        document.getElementById('royaltyPercent').value = 1;
        document.getElementById('royaltyAddress').value = cookiePayment.wallet.address || '';
        
        loadCollections(wallet.address);
        
        const form = document.getElementById("createNftForm");
        const resultEl = document.getElementById("result");
        
        form.addEventListener("submit", async (e) => {
          e.preventDefault();
        
          const collectionId = parseInt(document.getElementById("contractAddress").value);
          const name = document.getElementById("nftName").value.trim();
          const price = document.getElementById("nftPrice").value.trim();
          const description = document.getElementById("nftDescription").value.trim();
          const royaltyAddress = document.getElementById("royaltyAddress").value.trim();
          const royaltyPercent = parseFloat(document.getElementById("royaltyPercent").value);
          const maxMints = parseInt(document.getElementById("maxMints").value, 10);
        
          const fileInput = document.getElementById("nftImage");
          const file = fileInput.files[0];
        
          if (!file) {
            resultEl.textContent = "❌ Please upload an image.";
            return;
          }
        
          resultEl.textContent = "Creating NFT...";
        
          try {
            const formData = new FormData();
            formData.append('file', file);
        
            const uploadResponse = await fetch('/upload-to-lighthouse', {
              method: 'POST',
              headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
              },
              body: formData
            });
        
          let uploadResult;
          try {
            uploadResult = await uploadResponse.json();
          } catch {
            throw new Error('Invalid image. Ensure image is a jpg and below 1mb.');
          }
        
          if (!uploadResponse.ok || !uploadResult.cid) {
            throw new Error(uploadResult.error || 'Image upload failed');
  }
        
            const image = `ipfs://${uploadResult.cid}`;
        
            await fetch('/save-nft', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
              },
              body: JSON.stringify({
                collection_id: collectionId,
                owner: wallet.address,
                name,
                description,
                price,
                image,
                royalty_address: royaltyAddress,
                royalty_percent: royaltyPercent,
                max_mints: maxMints
              })
            });
        
            resultEl.textContent = "✅ NFT Created!";
            // window.location.href = '/collections';
        
          } catch (err) {
            console.error(err);
            resultEl.textContent = `❌ Error:\n${err.message || err}`;
          }
        });

        } else if (page === 'mint-nft') {
            
            const { name, image, owner, price } = window.nftData;
            
            appDiv.innerHTML = `
              <h1>${name}</h1>
            
              ${image ? `
                <img src="/ipfs/${image.replace('ipfs://', '')}" 
                     alt="${name}" 
                     class="img-fluid mb-4">
              ` : ''}
            
              <p><strong>Owner:</strong><p class="address">${owner}</p></p>
              <p><strong>Price:</strong> ${Number(price).toLocaleString()} Lunc</p>
            
              <div class="text-center">
                <button class="btn btn-primary" id="purchaseBtn">Mint NFT</button>
              </div>
            
              <div id="mintResult" class="mt-3 text-center"></div>
            `;


                const purchaseBtn = document.getElementById('purchaseBtn');
                const resultEl = document.getElementById('mintResult');
            
                if (purchaseBtn) {
                    purchaseBtn.addEventListener('click', async () => {
                        try {

                            purchaseBtn.remove();
                            
                            resultEl.innerHTML += `Please wait for your NFT to mint......`;
                            
                            const txHash = await mintNFT(window.nftData, cookiePayment.wallet); // Pass the data here
                            
                            resultEl.innerHTML = ""; 
            
                            resultEl.innerHTML += `NFT Minted! txHash: <a href="https://finder.terra.money/classic/tx/${txHash}" target="_blank" rel="noopener noreferrer">${txHash}</a>`;
                            
                            const backBtn = document.createElement('button');
                            backBtn.className = 'btn btn-secondary m-2';
                            backBtn.textContent = 'Back (Back to Collection)';
                            backBtn.addEventListener('click', () => {
                                window.location.href = `/collections/${window.nftData.collection_slug}`;
                            });
                        
                            const mintAgainBtn = document.createElement('button');
                            mintAgainBtn.className = 'btn btn-success m-2';
                            mintAgainBtn.textContent = 'Mint Again';
                            mintAgainBtn.addEventListener('click', () => {
                                window.location.reload();
                            });
                        
                            resultEl.appendChild(document.createElement('br'));
                            resultEl.appendChild(backBtn);
                            resultEl.appendChild(mintAgainBtn);
                            
                        } catch (err) {
                            console.error(err);
                            resultEl.textContent = `❌ Error:\n${err.message || err}`;
                        }
                    });
                }

    } else if (page === 'airdrop-holders'){


const appDiv = document.getElementById('app');
appDiv.innerHTML = `
<div class="panel">
    <select id="nftDropdown" class="form-select mt-3 mb-3 selection">
        <option disabled selected>Select an NFT Collection</option>
    </select>
    <button id="searchBtn" class="btn">Search NFT</button>
    <div id="nftContainer" class="d-flex flex-wrap"></div>
    <button id="nextBtn" class="btn hidden">Next</button>
    <div id="formContainer" class="hidden"></div>
    <div id="status"></div>
</div>`;

const dropdown = document.getElementById('nftDropdown');
const searchBtn = document.getElementById('searchBtn');
const statusDiv = document.getElementById('status');
const nftContainer = document.getElementById('nftContainer');
const nextBtn = document.getElementById('nextBtn');
const formContainer = document.getElementById('formContainer');
nextBtn.classList.add('hidden');

let selectedGroup = null;
let groupMap = {}; // holds group data for owners etc

// Load collections dynamically
(async () => {
    try {
        const response = await fetch('/get-allcollections');
        const collections = await response.json();
        collections.forEach(({ name, contract_address }) => {
            const option = document.createElement('option');
            option.value = contract_address;
            option.textContent = name;
            dropdown.appendChild(option);
        });
    } catch (err) {
        console.error("Error loading collections:", err);
    }
})();

// --- Rate limiter ---
function createRateLimiter(delay) {
    const queue = [];
    let active = false;

    async function runNext() {
        if (active || queue.length === 0) return;
        active = true;
        const { fn, resolve, reject } = queue.shift();
        try {
            const result = await fn();
            resolve(result);
        } catch (err) {
            reject(err);
        }
        setTimeout(() => {
            active = false;
            runNext();
        }, delay);
    }

    return function enqueue(fn) {
        return new Promise((resolve, reject) => {
            queue.push({ fn, resolve, reject });
            runNext();
        });
    };
}
const rateLimit = createRateLimiter(300);

// Fetch tokens for a collection
async function getTokens(contract) {
    const url = `https://terra-classic-lcd.publicnode.com/cosmwasm/wasm/v1/contract/${contract}/smart/eyJhbGxfdG9rZW5zIjp7InN0YXJ0X2FmdGVyIjpudWxsLCJsaW1pdCI6NTB9fQ==`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return data?.data?.tokens || [];
}

// Fetch NFT metadata
async function getNftData(contract, tokenId) {
    return rateLimit(async () => {
        const query = { nft_info: { token_id: tokenId } };
        const queryBase64 = btoa(JSON.stringify(query));
        const url = `https://terra-classic-lcd.publicnode.com/cosmwasm/wasm/v1/contract/${contract}/smart/${queryBase64}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        return data?.data?.extension || null;
    });
}

// Fetch NFT owner
async function getNftOwner(contract, tokenId) {
    return rateLimit(async () => {
        const query = { owner_of: { token_id: tokenId } };
        const queryBase64 = btoa(JSON.stringify(query));
        const url = `https://terra-classic-lcd.publicnode.com/cosmwasm/wasm/v1/contract/${contract}/smart/${queryBase64}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        return data?.data?.owner || null;
    });
}

// Search NFTs
searchBtn.addEventListener('click', async () => {
    const contract = dropdown.value;
    if (!contract) {
        statusDiv.textContent = "Please select a collection.";
        return;
    }

    dropdown.classList.add('hidden');
    searchBtn.classList.add('hidden');
    statusDiv.textContent = "Fetching NFTs (This may take some time)...";
    nftContainer.innerHTML = "";
    selectedGroup = null;
    groupMap = {};

    try {
        const tokens = await getTokens(contract);
        if (!tokens.length) {
            statusDiv.textContent = "No NFTs found.";
            return;
        }

        const tasks = tokens.map(async (tokenId) => {
            const metadata = await getNftData(contract, tokenId);
            const owner = await getNftOwner(contract, tokenId);
            return { tokenId, metadata, owner };
        });

        const settled = await Promise.allSettled(tasks);

        settled.forEach(result => {
            if (result.status !== 'fulfilled' || !result.value) return;
            const { tokenId, metadata, owner } = result.value;
            const groupName = metadata?.name || tokenId;
            const imageUrl = metadata?.image?.replace('ipfs://', '/ipfs/') || '';

            if (!groupMap[groupName]) groupMap[groupName] = { tokens: [], image: imageUrl, owners: [] };
            groupMap[groupName].tokens.push(tokenId);
            if (owner) groupMap[groupName].owners.push(owner);
        });

        Object.entries(groupMap).forEach(([groupName, data]) => {
            const div = document.createElement("div");
            div.classList.add("nftBlocks");

            const count = data.tokens.length;
            const countLabel = count === 1 ? "1 NFT" : `${count} NFTs`;

            const imgHtml = data.image
                ? `<img src="${data.image}" class="card-img-top" alt="${escapeHtml(groupName)}">`
                : `<div class="nftBlockImg-placeholder" aria-hidden="true"></div>`;

            div.innerHTML = `
                <div class="nftBlockImg">${imgHtml}</div>
                <div class="card-body">
                    <h5 class="card-title">${escapeHtml(groupName)}</h5>
                    <p class="card-text text-muted">${countLabel}</p>
                </div>`;

            div.addEventListener('click', () => {
                document.querySelectorAll('.nftBlocks.selected').forEach(el => el.classList.remove('selected'));
                div.classList.add('selected');
                selectedGroup = groupName;
                statusDiv.textContent = `You have selected: ${groupName}`;
                nextBtn.classList.remove('hidden');
            });

            nftContainer.appendChild(div);
        });
        
        statusDiv.textContent = "";

    } catch (err) {
        console.error(err);
        statusDiv.textContent = "Error fetching NFTs.";
    }
});

// Next button -> show form
nextBtn.addEventListener('click', () => {
    if (!selectedGroup) return;
    statusDiv.textContent = "";
    nftContainer.innerHTML = "";
    nextBtn.classList.add('hidden');
    formContainer.classList.remove('hidden');

    // --- Added: show holder count ---
    const holderCount = new Set(groupMap[selectedGroup].owners).size;
    const groupTitle = escapeHtml(selectedGroup);

    formContainer.innerHTML = `
        <h4>Send Tokens to ${holderCount} Holder${holderCount !== 1 ? 's' : ''} of "${groupTitle}"</h4>
        <form id="sendForm">
            <div class="form-group">
                <label for="tokenContract">Token Contract</label>
                <select id="tokenContract" class="form-select">
                    <option value="uluna">LUNC</option>
                    <option value="terra1ljyvgw50u67r3ep7pp7qexgnsgy96fl57q0suut325ehed7eal8qwdtdq4">Elpaco</option>
                    <option value="terra1m58hc296srr6xygrrfyu6u0e32pl8d459nfs55pmegke8zlv94rqsjz882">CatWifHat</option>
                    <option value="terra1vzhhsddfe558ug43kn5ct5d3aqj48wnvavlaue4d279eltsp9nnql6q549">ampCWH</option>
                    <option value="terra15p8su45k45axng8ue59rl6zph4at27s49u3agr6uqrx3dhcxpg3qt0ekdt">DO</option>
                    <option value="terra1c3m0mfshydl4dc27xmwun2g938delmpcd6tm7qr3vln8kh7ahwxsz526jm">TCR</option>
                    <option value="terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2">Juris</option>
                </select>
            </div>
            <div class="form-group mt-2">
                <label for="amount">Amount</label>
                <input type="number" id="amount" class="form-control" placeholder="Enter amount" required>
            </div>
            <button type="submit" class="btn mt-3">Send</button>
        </form>
    `;

    const sendForm = document.getElementById('sendForm');
    sendForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const token = document.getElementById('tokenContract').value;
        const amount = parseFloat(document.getElementById('amount').value);
        const holders = groupMap[selectedGroup].owners;

        if (!holders.length) {
            statusDiv.textContent = "No holders found for this group.";
            return;
        }

        statusDiv.textContent = "Sending tokens...";
        sendForm.querySelector('button[type="submit"]').disabled = true;

        try {
            const txHash = await sendTokens(wallet, wallet.address, holders, token, amount);
            statusDiv.innerHTML = `<p>View Transaction: <a href="https://finder.terra.money/classic/tx/${txHash}" target="_blank" rel="noopener noreferrer">${txHash}</a></p>`;
        } catch (err) {
            console.error(err);
            statusDiv.textContent = "Error sending tokens.";
            sendForm.querySelector('button[type="submit"]').disabled = false;
        }
    });
});

// Escape HTML
function escapeHtml(str) {
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}


        
    } else if (page === 'transfer'){

        appDiv.innerHTML = `

            <div class="panel">

                <select id="nftDropdown" class="form-select mt-3 mb-3 selection">

                    <option disabled selected>Select an NFT Collection</option>

                    <option value="custom">Custom NFT Address</option>

                </select>
                <input type="text" class="nftContract form-control mb-2 nselection" name="nftContract" placeholder="Enter Contract Address">

                <button id="searchBtn" class="btn">Search NFT</button>

                <div id="status"></div>

            </div>`;

    


        const dropdown = document.getElementById('nftDropdown');

        const nftInput = document.querySelector('.nftContract');

    
        
        const response = await fetch('/get-allcollections');
        const collections = await response.json(); // ✅ fix here
        
        collections.forEach(({ name, contract_address }) => {
          const option = document.createElement('option');
          option.value = contract_address;
          option.textContent = name;
          dropdown.appendChild(option);
        });

        let selectedValue;

        dropdown.addEventListener('change', (e) => {

            selectedValue = e.target.value;

            if (selectedValue === 'custom') {

                nftInput.style.display = 'block';

                nftInput.value = '';

                console.log(selectedValue);
            } else { 

                nftInput.style.display = 'none';

                nftInput.value = selectedValue;

                console.log(selectedValue);
            }

        });
        
            if(document.getElementById('searchBtn')){
                document.getElementById('searchBtn').addEventListener('click', async () => {
                console.log(selectedValue);
    
                    const status = document.getElementById('status');
    
                    const searchBtn = document.getElementById('searchBtn');
    
                    searchBtn.disabled = true;
    
            
    
                    const dropdownValue = document.getElementById('nftDropdown').value;
    
                    let nftAddress;
                    console.log("1 - " + nftAddress);
    
                
    
                    if (selectedValue === 'custom') {
    
                        nftAddress = document.querySelector('.nftContract').value;
                    console.log("2 - " + nftAddress);
    
                        if (!nftAddress) {
    
                            status.innerText = "❗ Please enter a custom NFT address.";
    
                            searchBtn.disabled = false;
    
                            return;
    
                        }
    
                    } else {
    
                       nftAddress = nftAddress;
    
                    }
    
        
    
                    const tokenIds = await checkOwnedNFTs(cookiePayment.wallet.address, nftAddress);
    
        
    
                    if (tokenIds.length === 0) {
    
                        status.innerText = "❌ No NFTs found for this wallet.";
    
                    } else {
    
                      appDiv.innerHTML = `
    
                        <div class="panel">
    
                            <div id="nftList" class="d-flex flex-wrap gap-2"></div>
    
                            <div id="status"></div>
    
                        </div>`;
    
        
    
                     const nftList = document.getElementById('nftList');
    
            
    
                     for (const tokenId of tokenIds) {
    
                   
                            try {
                                const [name, imageUrl] = await getInfo(nftAddress, tokenId);
                            
                                const container = document.createElement('div');
                                container.classList.add('nftBlocks');
                            
                                // Create a div to wrap the image with class 'nftBlockImg'
                                const imageWrapper = document.createElement('div');
                                imageWrapper.classList.add('nftBlockImg');
                            
                                const img = document.createElement('img');
                                img.src = imageUrl;
                                img.alt = name || tokenId;
                                img.classList.add('card-img-top');
                                img.dataset.tokenId = tokenId;
                            
                                imageWrapper.appendChild(img);        // Add img to wrapper
                                container.appendChild(imageWrapper);  // Add wrapper to container
                            
                                const nftName = document.createElement('div');
                                nftName.classList.add('nftName');
                                nftName.textContent = name || 'Unnamed NFT';
                            
                                container.appendChild(nftName);
                                nftList.appendChild(container);
                            
                            } catch (err) {
                                const p = document.createElement('p');
                                p.textContent = `Error loading token ${tokenId}: ${err.message || err}`;
                                nftList.appendChild(p);
                            }

    
                        }
    
                    }
    
        
    
                    searchBtn.disabled = false;
    
        
    
                    document.querySelectorAll('.nftBlocks').forEach(nftElement => {
    
                        nftElement.addEventListener('click', () => {
    
                        const isSelected = nftElement.classList.contains('selectedNFT');
    
        
    
                        document.querySelectorAll('.singleNft').forEach(el => el.classList.remove('selectedNFT'));
    
                        let selectedNft = null;
    
        
    
                        if (!isSelected) {
    
                            nftElement.classList.add('selectedNFT');
    
        
    
                            const name = nftElement.querySelector('.nftName')?.textContent || '';
    
                            const tokenId = nftElement.querySelector('img')?.dataset.tokenId || '';
    
                            selectedNft = [name, tokenId];
    
                            window.selectedNft = selectedNft;
    
                        } else {
    
                            window.selectedNft = null;
    
                        }
    
        
    
                        let continueBtn = document.getElementById('continueBtn');
    
                        let advertiseBtn = document.getElementById('advertiseBtn');
    
                        let recipientInput = document.getElementById('recipientInput');
    
                        
    
                        const currentPath = window.location.pathname;
    
                    
    
                        if (currentPath.endsWith('/advertise.html')) {
    
                            if (selectedNft) {
    
                                const name = selectedNft[0];
    
                                const tokenId = selectedNft[1];
    
                                const nftImage = nftElement.querySelector('img')?.src || '';
    
                            
    
                                // Create input fields only once
    
                                if (!document.getElementById('adPrice')) {
    
                                    const priceInput = document.createElement('input');
    
                                    priceInput.id = 'adPrice';
    
                                    priceInput.className = 'form-control mt-3';
    
                                    priceInput.placeholder = 'Enter price in LUNC';
    
                                    priceInput.type = 'number';
    
                                    priceInput.min = 0;
    
                                    
    
                                    const telegramInput = document.createElement('input');
    
                                    telegramInput.id = 'adTelegram';
    
                                    telegramInput.className = 'form-control mt-2';
    
                                    telegramInput.placeholder = 'Enter your Telegram profile link';
    
                                    telegramInput.type = 'url';
    
                                    
    
                                    const endDateInput = document.createElement('input');
    
                                    endDateInput.id = 'adEndDate';
    
                                    endDateInput.className = 'form-control mt-2';
    
                                    endDateInput.placeholder = 'Select sale end date';
    
                                    endDateInput.type = 'date';
    
                                    
    
                                    const nftList = document.getElementById('nftList');
    
                                    nftList.after(priceInput, telegramInput, endDateInput);
    
                                }
    
                    
    
                                // Create Advertise button if it doesn't exist
    
                                if (!advertiseBtn) {
    
                                    advertiseBtn = document.createElement('button');
    
                                    advertiseBtn.id = 'advertiseBtn';
    
                                    advertiseBtn.className = 'btn btn-warning mt-3';
    
                                    advertiseBtn.textContent = 'Advertise';
    
                                    
    
                                    const endDateInput = document.getElementById('adEndDate');
    
                                    endDateInput.after(advertiseBtn);
    
                    
    
                                     // Async click handler here
    
                                     advertiseBtn.addEventListener('click', async () => {
    
                                        const now = new Date();
    
                                        const dateStr = now.toLocaleString();
    
                                        const sellerAddress = cookiePayment.wallet.address;
    
                                        const price = document.getElementById('adPrice')?.value.trim() || '';
    
                                        const telegram = document.getElementById('adTelegram')?.value.trim() || '';
    
                                        const endDate = document.getElementById('adEndDate')?.value || '';
    
                                        
    
                                        const adData = {
    
                                            name,
    
                                            image: nftImage,
    
                                            listedAt: dateStr,
    
                                            seller: sellerAddress,
    
                                            priceLUNC: price,
    
                                            telegramLink: telegram,
    
                                            saleEnds: endDate, 
                                            
                                            listingStatus: 'active'
    
                                        };
    
                    
    
                                        try {
    
                                            const res = await fetch('/save-ad.php', {
    
                                                method: 'POST',
    
                                                headers: {
    
                                                  'Content-Type': 'application/json'
    
                                                },
    
                                                body: JSON.stringify(adData)
    
                                             });
    
                                
    
                                            if (!res.ok) throw new Error('Failed to save ad.');
    
                                            
    
                                            const result = await res.text();
    

                                            alert('Ad submitted successfully!');
    
                                        } catch (err) {
    
                                            console.error('❌ Save failed:', err);
    
                                            alert('Failed to submit ad.');
    
                                        }
    
                                    });
    
                                }
    
                            } else {
    
                                // Remove all inputs and button if NFT is deselected
    
                                ['adPrice', 'adTelegram', 'adEndDate', 'advertiseBtn'].forEach(id => {
    
                                    const el = document.getElementById(id);
    
                                    if (el) el.remove();
    
                                });
    
                            }
    
                        } else {
    
        
    
                            if (selectedNft) {
    
                                if (!recipientInput) {
    
                                    recipientInput = document.createElement('input');
    
                                    recipientInput.id = 'recipientInput';
    
                                    recipientInput.className = 'form-control mt-3';
    
                                    recipientInput.placeholder = 'Enter recipient address';
    
                                    
    
                                    const nftList = document.getElementById('nftList');
    
                                    nftList.after(recipientInput);
    
                                }
    
                
    
                            if (!continueBtn) {
    
                                continueBtn = document.createElement('button');
    
                                continueBtn.id = 'continueBtn';
    
                                continueBtn.className = 'btn btn-success mt-3';
    
                                continueBtn.textContent = 'Continue';
    
                
    
                                recipientInput.after(continueBtn);
    
                
    
                                continueBtn.addEventListener('click', async () => {
    
                                    const recipient = recipientInput.value.trim();
    
                                    if (!recipient) {
    
                                        alert('❗ Please enter a recipient address.');
    
                                        return;
    
                                    }
    
                
    
                                    const status = document.getElementById('status');
    
                                    continueBtn.disabled = true;
    
                
    
                                    try {
    
                                        status.innerText = 'Sending transaction...';
    
                                            const txHash = await transferNft(
    
                                            cookiePayment.wallet,
    
                                            cookiePayment.wallet.address,
    
                                            recipient,
    
                                            nftAddress,
    
                                            selectedNft[1],
    
                                            selectedNft[0]
    
                                        );
    
                                        status.innerHTML = `✅ Sent! Tx Hash: <a href="https://finder.terra.money/classic/tx/${txHash}" target="_blank" rel="noopener noreferrer">${txHash}</a>`;
    
                                    } catch (err) {
    
                                        status.innerText = `❌ Error: ${err.message}`;
    
                                    } finally {
    
                                        continueBtn.disabled = false;
    
                                    }
    
                                });
    
                            }
    
                        } else {
    
                            if (continueBtn) continueBtn.remove();
    
                            if (recipientInput) recipientInput.remove();
    
                        }
    
                    }
    
                });
    
            });
    
            });
        
        }

    } else {
      appDiv.innerHTML = `
        <div class="panel">
          <h2>Wallet Connected</h2>
          <p><strong>Address:</strong> ${address}</p>
          ${welcomeMsg}
        </div>
      `;
    }

  } catch (err) {
    alert('Wallet connection failed: ' + err.message);
    console.error(err);
  }
};


async function loadCollections(walletAddress) {
  const select = document.getElementById('contractAddress');
  try {
    const res = await fetch(`/my-collections/${walletAddress}`);
    const data = await res.json();

    select.innerHTML = ''; // Clear previous
    if (data.length === 0) {
      select.innerHTML = '<option value="">No collections found</option>';
      return;
    }

    for (const collection of data) {
      const opt = document.createElement('option');
      opt.value = collection.id; // ← Store the PK ID here
      opt.textContent = collection.name;
      select.appendChild(opt);
    }

  } catch (err) {
    select.innerHTML = '<option value="">Error loading collections</option>';
    console.error('Failed to load collections:', err);
  }
}

document.addEventListener("DOMContentLoaded", () => {
    const isInIframe = window.self !== window.top;

    if (isInIframe) {
        const select = document.getElementById("walletSelection");

        if (!select) return;

        // Extension wallets to hide in iframe
        const extensionWallets = [
            "keplr",
            "station",
            "galaxy"
        ];

        extensionWallets.forEach(value => {
            const option = select.querySelector(`option[value="${value}"]`);
            if (option) option.remove();
        });
    }

    if (isInIframe) {
        document.body.classList.add("in-iframe");
    }
});